/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions 1 through 8, plus the special nil and max UUIDs. Timestamps are decoded for v1 (Gregorian time) and v7 (Unix time); v4 is random and has no timestamp.`)
};

const es_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiones 1 a 8, más los UUID especiales nil y max. Las marcas de tiempo se decodifican para v1 (hora gregoriana) y v7 (hora Unix); v4 es aleatorio y no tiene marca de tiempo.`)
};

const de_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Versionen 1 bis 8 sowie die speziellen nil- und max-UUIDs. Zeitstempel werden für v1 (gregorianische Zeit) und v7 (Unix-Zeit) decodiert; v4 ist zufällig und besitzt keinen Zeitstempel.`)
};

const nl_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versies 1 tot en met 8, plus de speciale UUID's nil en max. Tijdstempels worden gedecodeerd voor v1 (Gregoriaanse tijd) en v7 (Unix-tijd); v4 is willekeurig en heeft geen tijdstempel.`)
};

const fr_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les versions 1 à 8, plus les UUID spéciaux nil et max. Les horodatages sont décodés pour v1 (heure grégorienne) et v7 (heure Unix) ; v4 est aléatoire et n'a pas d'horodatage.`)
};

const it_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioni da 1 a 8, più gli UUID speciali nil e max. I timestamp vengono decodificati per v1 (ora Gregoriana) e v7 (ora Unix); v4 è casuale e non ha un timestamp.`)
};

const pt_br2_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versões 1 a 8, mais os UUIDs especiais nil e max. Timestamps são decodificados para v1 (tempo Gregoriano) e v7 (tempo Unix); v4 é aleatório e não tem timestamp.`)
};

const pt_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versões 1 a 8, mais os UUIDs nil e max especiais. Os timestamps são descodificados para v1 (hora Gregoriana) e v7 (hora Unix); v4 é aleatório e não tem timestamp.`)
};

const ja_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バージョン 1 から 8、および特別な nil と max UUID。タイムスタンプは v1 (グレゴリオ暦) および v7 (Unix 時刻) でデコードされます。v4 はランダムでタイムスタンプがありません。`)
};

const zh_ud_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本 1 到 8,以及特殊的 nil 和 max UUID。时间戳会针对 v1(格里高利历时间)和 v7(Unix 时间)进行解码;v4 是随机生成的,没有时间戳。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq1_a", locale)
	if (locale === "en") return en_ud_faq1_a(inputs)
	if (locale === "es") return es_ud_faq1_a(inputs)
	if (locale === "de") return de_ud_faq1_a(inputs)
	if (locale === "nl") return nl_ud_faq1_a(inputs)
	if (locale === "fr") return fr_ud_faq1_a(inputs)
	if (locale === "it") return it_ud_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq1_a(inputs)
	if (locale === "pt") return pt_ud_faq1_a(inputs)
	if (locale === "ja") return ja_ud_faq1_a(inputs)
	return zh_ud_faq1_a(inputs)
};